import FloorMap from "./floorMap";
export default FloorMap;
